import type { PrinterService, Ticket } from '../types';

export class WebPrinter implements PrinterService {
  async isAvailable(): Promise<boolean> {
    return true;
  }

  async print(ticket: Ticket): Promise<void> {
    const win = window.open('', '_blank', 'width=400,height=600');
    if (!win) {
      alert('Autorisez les popups pour imprimer.');
      return;
    }

    const lines = ticket.lines
      .map(
        (l) => `
        <tr>
          <td>${l.label}</td>
          <td style="text-align:center">${l.qty}</td>
          <td style="text-align:right">${(l.qty * l.price).toFixed(2)} €</td>
        </tr>`,
      )
      .join('');

    win.document.write(`<!DOCTYPE html>
      <html>
      <head>
        <meta charset="utf-8">
        <style>
          body { font-family: monospace; width: 300px; margin: 0 auto; padding: 10px; font-size: 12px; }
          h2 { text-align: center; margin: 0 0 5px; }
          p { text-align: center; margin: 2px 0; }
          table { width: 100%; border-collapse: collapse; margin: 10px 0; }
          td { padding: 2px 0; }
          .total { font-weight: bold; font-size: 14px; text-align: center; margin-top: 10px; border-top: 1px dashed #000; padding-top: 5px; }
          .footer { text-align: center; margin-top: 10px; font-size: 10px; }
        </style>
      </head>
      <body>
        <h2>${ticket.shopName}</h2>
        <p>${ticket.date.toLocaleDateString('fr-FR')} ${ticket.date.toLocaleTimeString('fr-FR')}</p>
        <table>${lines}</table>
        <div class="total">Total : ${ticket.total.toFixed(2)} €</div>
        <div class="footer">Merci de votre visite</div>
      </body>
      </html>
    `);
    win.document.close();
    win.focus();
    win.print();
    win.close();
  }
}
